import { css, keyframes } from "styled-components";
const spin = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
`;
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    .beta-loader-container {
      top: 0;
      left: 0;
      z-index: 99;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(15 25 35 / 80%);

      svg {
        color: ${paletteTokens.bladebg1};
        animation: ${spin} 700ms linear infinite;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map